export const getUsers = ({ page, perPage } = { page: 1, perPage: 50 }) =>
  `/api/utilisateurs?page=${page}${perPage ? `&perPage=${perPage}` : ''}`;
